import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TagsComponent } from './tags/tags.component';
import { TagsListComponent } from './tags-list/tags-list.component';
import { TagsEditComponent } from './tags-edit/tags-edit.component';
import { TagsNewComponent } from './tags-new/tags-new.component';


const cRoutes: Routes = [

  {
    path: '',
    component: TagsComponent,
    children: [
        {
          path: 'list',
          component: TagsListComponent
        },
        {
          path: 'edit/:id',
          component: TagsEditComponent
        },
        {
          path: 'new',
          component: TagsNewComponent
        },
        {
          path: '',
          redirectTo: 'list',
          pathMatch: 'full'
        }
    ]
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(
      cRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})

export class StatusRoutingModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/tags/tags-routing.module.ts